import gql from 'graphql-tag';

export const NAVIGATION_QUERY = gql`
  query GetPage($uid: String!) {
    navigations(where: { uid: $uid }) {
      ...sidenavs
      ...subnavs
    }
  }

  fragment sidenavs on Navigation {
    title
    statement
    externalUrl
    displayOrder
    icon: icon_class
    type
  }

  fragment subnavs on Navigation {
    children: sub_navigations {
      ...sidenavs
      children: sub_navigations {
        ...sidenavs
        children: sub_navigations {
          ...sidenavs
          children: sub_navigations {
            ...sidenavs
          }
        }
      }
    }
  }
`;
